import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import * as Highcharts from 'highcharts';
import * as _ from 'lodash';

@Component({
    selector: 'ea-pie-chart',
    templateUrl: './ea-pie.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./ea-pie.component.scss'],
    standalone: false
})
export class EaPieComponent implements OnInit {
  Highcharts: typeof Highcharts = Highcharts;
  @Input() options: any;
  @Input() data: any;
  @Input() title: any;
  @Input() i18n = true;
  @Input() height: number;
  @Output() pieClicked = new EventEmitter();

  pieOptions: any;

  constructor(private translate: TranslateService) {}

  ngOnInit() {
    this.initOptions();
  }

  initOptions(): void {
    let opt = this.getDefaultOption();
    if (this.options) {
      opt = _.merge(opt, this.options);
      this.pieOptions = opt;
    }

    /* format pie series data */
    if (this.data && this.data instanceof Array) {
      let tmp = [];
      this.data.forEach(d => {
        let o = Object.assign({ y: d.value, name: d.label }, d);
        if (this.i18n && d.label) {
          this.translate.get(d.label).subscribe(value => {
            o.name = value;
            tmp.push(o);
          });
        } else {
          tmp.push(o);
        }
      });

      opt.series = [
        {
          name: 'Répartition',
          data: tmp,
        },
      ];

      this.pieOptions = opt;
    }
  }

  getDefaultOption(): any {
    let that = this;
    let defaultOptions = {
      colors: [
        '#4ea2c6',
        '#c1ca55',
        '#4a6860',
        '#f7a25d',
        '#7093e7',
        '#0f7574',
        '#595d56',
        '#d3d6df',
        '#afa72a',
      ],
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie',
        spacingTop: 0,
        spacingBottom: 0,
        height: this.height || null,
      },
      credits: {
        enabled: false,
      },
      tooltip: {
        headerFormat: '',
        pointFormat:
          '{point.name}: <span style="color:#e69800;font-weight:600;">{point.percentage:.1f}%</span><br><b>{point.y} €</b>',
        valueDecimals: 2,
      },
      title: {
        text: '',
      },
      plotOptions: {
        pie: {
          minSize: 120,
          size: 260,
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: false,
          },
          showInLegend: true,
          events: {
            click: function (event) {},
          },
          point: {
            events: {
              legendItemClick: function (event) {
                event.preventDefault();
                this.select();
                if (this.options) {
                  that.pieClicked.emit(this.options);
                }
              },
            },
          },
        },
      },
      legend: {
        align: 'right',
        verticalAlign: 'middle',
        layout: 'vertical',
        itemMarginTop: 4,
        itemMarginBottom: 4,
        useHTML: true,

        itemStyle: {
          textTransform: 'uppercase',
        },
        labelFormat: `
        <span style="color:#31708f;vertical-align:top;">{percentage:.1f} %</span>
        <span style="max-width:290px;text-overflow:ellipsis;overflow:hidden;display:inline-block;">{name}</span>`,
      },
      responsive: {
        rules: [
          {
            condition: {
              maxWidth: 615,
            },
            chartOptions: {
              legend: {
                align: 'center',
                verticalAlign: 'bottom',
                layout: 'horizontal',
              },
              plotOptions: {
                pie: {
                  size: 180,
                },
              },
            },
          },
        ],
      },
      series: [],
    };

    return defaultOptions;
  }

  pieClickHandler(event): void {
    if (event && event.point && event.point.options) {
      this.pieClicked.emit(event.point.options);
    }
  }
}
